import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const normalizeOptions = (items = []) => items.map((item) => ({
    value: item.value ?? item.id ?? item.name ?? item.text,
    label: item.label ?? item.text ?? item.namewar ?? item.name ?? item.id ?? item.value,
}));

const DispatchListOptionsService = {
    getAttendanceChannelFullList: async () => axios.get(`${API_URL}/despacho/getAttendanceChannelFullList`)
        .then(({data}) => normalizeOptions(data))
        .catch((err) => { throw err }),

    contingents: async (entity = "garrison") => axios.get(`${API_DESPACHO}/garrison/listFilterContingent/`, {params: {entity}})
        .then(({data}) => normalizeOptions(data))
        .catch((err) => { throw err }),

    dispatchNatures: async () => axios.get(`${API_URL}/nature/get/dispatchNatures`)
        .then(({data}) => normalizeOptions(data))
        .catch((err) => { throw err }),

    dispatchProvidences: async () => axios.get(`${API_URL}/providence/get/dispatchProvidences`)
        .then(({data}) => normalizeOptions(data))
        .catch((err) => { throw err }),
};

export default DispatchListOptionsService;
